module.exports = __webpack_public_path__ + "static/bottom-segment-e14fa52a3160a5aba587220e28b12332.png";